import _ from 'lodash';
import { createSelector } from 'reselect';

import CadminCompaniesAx         from 'app/actions/company-admin/companies';
import CadminEmployeeDonationsAx from 'app/actions/company-admin/employee-donations';
import ToastAx                   from 'app/actions/toast';
import {
  DonatableTypes,
  CompanyNonprofitApprovalStatuses as ApprovalStatuses,
}                                from 'app/constants';
import CadminNonprofitsDuck      from 'app/ducks/company-admin/nonprofits';
import reducerUtils              from 'app/reducers/utils';
import CadminSlx                 from 'app/selectors/company-admin/';
import EntitiesSlx               from 'app/selectors/entities';
import RoutingSlx                from 'app/selectors/routing';



/*
 *  Actions
 */

const Types = {
  LOAD: 'CADMIN_PAGE_MATCH_LOAD',
  APPROVE: 'CADMIN_PAGE_MATCH_APPROVE',
  BAN: 'CADMIN_PAGE_MATCH_BAN',
};

const Ax = {

  load: ({params, query}) => (dispatch, getState) => {
    const promise = Promise.all([
      dispatch(CadminCompaniesAx.loadCommon(params.companySlug)),
      dispatch(CadminEmployeeDonationsAx.get(params.companySlug, params.employeeDonationId)),
    ]);
    return dispatch({type: Types.LOAD, promise});
  },

  approve: (ed) => (dispatch, getState) => {
    const companyId = CadminSlx.companyId(getState());
    const promise = dispatch(CadminNonprofitsDuck.Ax.setApprovalStatus(companyId, ed.donatableId, ApprovalStatuses.APPROVED)).then(() => {
      return dispatch(CadminEmployeeDonationsAx.get(companyId, ed.id));
    });
    return dispatch({type: Types.APPROVE, promise});
  },

  ban: (ed) => (dispatch, getState) => {
    const companyId = CadminSlx.companyId(getState());
    const promise = dispatch(CadminNonprofitsDuck.Ax.setApprovalStatus(companyId, ed.donatableId, ApprovalStatuses.BANNED)).then(() => {
      return dispatch(CadminEmployeeDonationsAx.get(companyId, ed.id));
    });
    return dispatch({type: Types.BAN, promise});
  },

};



/*
 *  Reducer
 */

const initialState = {
  isLoading: false,
  approvePending: false,
  banPending: false,
};

const reducer = reducerUtils.createReducer(initialState, {

  [`${Types.LOAD}_PENDING`]: (state, action) => {
    return {...state,
      isLoading: true,
    };
  },
  [`${Types.LOAD}_RESOLVED`]: (state, action) => {
    return {...state,
      isLoading: false,
    };
  },
  [`${Types.LOAD}_REJECTED`]: (state, action) => {
    return {...state,
      isLoading: false,
    };
  },

  [`${Types.APPROVE}_PENDING`]: (state, action) => {
    return {...state,
      approvePending: true,
    };
  },
  [`${Types.APPROVE}_RESOLVED`]: (state, action) => {
    return {...state,
      approvePending: false,
    };
  },
  [`${Types.APPROVE}_REJECTED`]: (state, action) => {
    return {...state,
      approvePending: false,
    };
  },

  [`${Types.BAN}_PENDING`]: (state, action) => {
    return {...state,
      banPending: true,
    };
  },
  [`${Types.BAN}_RESOLVED`]: (state, action) => {
    return {...state,
      banPending: false,
    };
  },
  [`${Types.BAN}_REJECTED`]: (state, action) => {
    return {...state,
      banPending: false,
    };
  },

});



/*
 *  Selectors
 */

const Slx = (() => {

  const selIsLoading      = (state) => state.companyAdmin.pageMatch.isLoading;
  const selApprovePending = (state) => state.companyAdmin.pageMatch.approvePending;
  const selBanPending     = (state) => state.companyAdmin.pageMatch.banPending;

  const selEmployeeDonation = createSelector(
    [RoutingSlx.params, EntitiesSlx.employeeDonations],
    (params, edMap, employeeMap, campaignMap, donatableMap) => {
      const ed = edMap[params.employeeDonationId];
      return ed || null;
    }
  );

  const selCampaign = createSelector(
    [selEmployeeDonation, EntitiesSlx.campaigns],
    (ed, campaignMap) => {
      return campaignMap[ed?.campaignId] || null;
    }
  );

  const selEmployee = createSelector(
    [selEmployeeDonation, EntitiesSlx.employees],
    (ed, employeeMap) => {
      return employeeMap[ed?.employeeId] || null;
    }
  );

  const selDonatable = createSelector(
    [selEmployeeDonation, EntitiesSlx.donatables],
    (ed, donatableMap) => {
      return donatableMap[ed?.donatableId] || null;
    }
  );

  const selNonprofit = createSelector(
    [selEmployeeDonation, selDonatable],
    (ed, donatable) => {
      const isNonprofit = ed?.donatableType === DonatableTypes.NONPROFIT;
      if (!isNonprofit) return null;
      return donatable;
    }
  );

  return {
    isLoading: selIsLoading,
    approvePending: selApprovePending,
    banPending: selBanPending,
    employeeDonation: selEmployeeDonation,
    campaign: selCampaign,
    employee: selEmployee,
    donatable: selDonatable,
    nonprofit: selNonprofit,
  };

})();



export {Types, Ax, reducer, Slx};
export default {Types, Ax, reducer, Slx};
